import { useState } from "react";
import { uniqBy } from "lodash";
import debounce from "lodash/debounce";
import { useFetchLesson } from "./useFetchLesson";
import { useFetchLessons } from "./useFetchLessons";

interface Lesson {
  course_name: string;
  id: string;
  name: string;
  section_name: string;
}

const lessonOptionFormatter = (lesson: Lesson) => ({
  label: lesson.name,
  value: lesson.id,
  description: `${lesson.course_name} • ${lesson.section_name}`,
});

export const useLessonSelector = ({
  selectedLessonId,
  onlyQuizzes = false,
}: {
  selectedLessonId: string | null;
  onlyQuizzes?: boolean;
}) => {
  const [lessonName, setLessonName] = useState("");
  const { data, isLoading: isLoadingLessons } = useFetchLessons({
    name: lessonName,
    onlyQuizzes,
  });
  const {
    data: lesson,
    isLoading: isLoadingLesson,
    isSuccess: isLessonLoaded,
  } = useFetchLesson({
    lessonId: selectedLessonId,
  });
  const lessons = data?.records ?? [];

  let lessonOptions = lessons.map(lessonOptionFormatter);

  if (lesson && !isLoadingLesson && isLessonLoaded) {
    lessonOptions = uniqBy(
      [...lessonOptions, lessonOptionFormatter(lesson)],
      "value",
    );
  }

  const handleLessonTitleChange = debounce(
    (title: string) => setLessonName(title),
    500,
  );

  return {
    isLoading: isLoadingLessons || isLoadingLesson,
    lessonOptions,
    handleLessonTitleChange,
  };
};
